import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
})
export class FilterByPipe implements PipeTransform {
  transform(value: any | any[], field?: string, search?: string): any[] {
    if (!value || !field || !search) {
      return value;
    }
    const lowerSearch = search.toLowerCase();
    return value.filter((item) => {
      return (
        item[field] &&
        item[field].includes &&
        item[field].toLowerCase().includes(lowerSearch)
      );
    });
  }
}
